module.exports = __webpack_public_path__ + "static/media/Importar.dfe13e85.svg";